import { createStore } from 'vuex';
import loader from './loader';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    loader
  },
});
